
import { Component, OnInit, ViewChild, ElementRef, Inject, Input } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { ExoStarService } from 'src/app/Services/ExoStar/exo-star.service';
import { Router } from '@angular/router';
import { IReportParameters } from 'src/app/models/IReportParameters';
import { ShowSSRSReportComponent } from 'src/app/ChildControls/show-ssrsreport/show-ssrsreport.component';
import { MatSort } from '@angular/material';
import { parse } from '@fullcalendar/core/datelib/parsing';
import { IEpcsRxAuditLog } from 'src/app/models/IEpcsRxAuditLog';
import { ExportToCsv } from 'export-to-csv';
import * as XLSX from 'xlsx';
import { PatientMedicationActionservice, PatientMedicationAction } from 'src/app/Services/common.service';
import { IAttributes } from 'src/app/models/IAttributes';

@Component({
  selector: 'app-epcs-audit-log',
  templateUrl: './epcs-audit-log.component.html',
  styleUrls: ['./epcs-audit-log.component.css']
})
export class EpcsAuditLogComponent implements OnInit {

  EpcsRxAuditForm: FormGroup;
  public physicianList: IUserDetails[];
  selected: any = "";
  provider: string = "";
  patient: string = "";
  ToDate: string = "";
  FromDate: string = "";
  drugDesc: string = "";
  totalAuditlogRecords: number = 0;
  displayedColumns = ['createdOn', 'eventCreatedBy', 'providerName', 'patientName', 'drugDescription', 'scheduleType', 'eventType', 'eventStatus'];
  dataSource = new MatTableDataSource();
  patientMedicationList: PatientMedicationAction[] = [];
  sourceMedStatusdata: IAttributes[] = [];
  //dataSource = new MatTableDataSource<IEpcsRxAuditLog>();
  constructor(private formBuilder: FormBuilder, private toastr: ToastrService, private sharedService: SharedService, private router: Router,
    private datePipe: DatePipe, private ExoStarServices: ExoStarService, public dialog: MatDialog, public patientMedicationdAction: PatientMedicationActionservice
    , @Inject(MAT_DIALOG_DATA) public data: DialogData
    , public dialogRef: MatDialogRef<EpcsAuditLogComponent>) {
  }

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('Auditlogs', { static: true }) Auditlogs: ElementRef;// MatTable<IEpcsRxAuditLog[]>;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @Input() isRx: boolean = true;
  ngOnInit() {
     
    this.dataSource.paginator = this.paginator;
    this.EpcsRxAuditForm = this.formBuilder.group({
      providers: [''],
      patientName: [''],
      drug: [''],
      fromDate: [''],
      toDate: [''],
      medicationStatus: [''],
    });
    if (this.data != null && this.data.isRx == false) {
      this.isRx = false;
    }
    if (this.isRx == false) {
      this.getAllEpcsRxInfo();
    }
    else {
      this.getAllProviders();
      this.getAllEpcsRxInfo();
      //this.getAllMedicationStatus();
      this.medicationStatusDropDownBinding();
    }

  }
  getAllMedicationStatus() {
    this.patientMedicationList = [];
    let ActionList = this.patientMedicationdAction.getPatientMedicationMenus();
    this.patientMedicationList = ActionList;
  }
  getAllProviders() {
    this.sharedService.getAllUsersByRole("Doctor").subscribe(data => {
      this.physicianList = data;
    });
  }

  medicationStatusDropDownBinding() {
    var attrType = 67;
    this.sharedService.getAttributesById(attrType).subscribe((data: IAttributes[]) => {
      // this.dataSource = data;
      this.sourceMedStatusdata = data;
      var obj: IAttributes = {
        attributeId: '5',
        attributeType: '67',
        attributeName: 'Signed',
        attributeDesc: 'Signed',
        isActive: true,
        createdBy: 'Admin',
        createdOn: new Date(),
        modifiedBy: 'Admin',
        modifiedOn: new Date(),
        dbOperations: 'Read',
        claimCode: '',
        encounterId: '',
        selected: null
      };
      this.sourceMedStatusdata.push(obj);
    });
  }
  //isRx:boolean=true;
  initiateParamters() {
    var providerName = encodeURIComponent(this.EpcsRxAuditForm.value.providers);
    var patientN = this.EpcsRxAuditForm.value.patientName;
    var drugDescription = this.EpcsRxAuditForm.value.drug.trim();
    var prescStatus = this.EpcsRxAuditForm.value.medicationStatus;
    var LToDate = this.datePipe.transform(this.EpcsRxAuditForm.value.toDate, 'MM/dd/yyy');
    // alert(LToDate)
    if (LToDate != null) {
      this.ToDate = LToDate;
    } else {
      this.ToDate = "";
    }

    var LFromDate = this.datePipe.transform(this.EpcsRxAuditForm.value.fromDate, 'MM/dd/yyyy');

    if (LFromDate != null) {
      this.FromDate = LFromDate;
    } else {
      this.FromDate = "";
    }

    if (providerName != "" && providerName != undefined) {
      this.provider = providerName;
    } else {
      this.provider = "";
    }

    if (patientN != null && patientN != "") {
      this.patient = patientN;
    } else {
      this.patient = "";
    }

    if (drugDescription != null && drugDescription != "") {
      this.drugDesc = drugDescription;
    } else {
      this.drugDesc = "";
    }

    if (prescStatus != null && prescStatus != "") {
      this.prescriptionStatus = prescStatus;
    } else {
      this.prescriptionStatus = "";
    }
  }

  public status = "";
  public createdondate = "";
  public prescriptionStatus = '';
  //epcsAuditList:IEpcsRxAuditLog[];
  getAllEpcsRxInfo() {
     
    if (this.EpcsRxAuditForm.value.toDate != null && this.EpcsRxAuditForm.value.toDate != undefined && this.EpcsRxAuditForm.value.toDate != "") {
      if (this.EpcsRxAuditForm.value.fromDate === null || this.EpcsRxAuditForm.value.fromDate === undefined || this.EpcsRxAuditForm.value.fromDate === "") {
        this.toastr.warning("Enter From Date");
        return;
      }
    }
    this.initiateParamters();
    if (this.isRx == true) {
      this.isRx = true;
      this.ExoStarServices.searchEPCSRxAuditLogDetails(this.patient, this.drugDesc, this.provider, this.ToDate, this.FromDate, this.prescriptionStatus).subscribe(
        results => {
          // this.epcsAuditList=results;
          this.dataSource.data = results;
          if (results.length > 0 && results.length != null) {
            this.totalAuditlogRecords = results.length;
            this.dataSource.sort = this.sort;
          } else {
            this.totalAuditlogRecords = results.length;
          }

          //this.dataSource.data = this.epcsAuditList;

          setTimeout(() => {
            this.dataSource.sort = this.sort;
          })
        }, (err: any) => {
          console.log(err);
        });
    }
    else {
      this.isRx = false;
      //alert(this.data.drug);
      var dt = new Date();
      var fromdt = this.datePipe.transform(new Date(dt.setMonth(dt.getMonth() - 6)), 'MM-dd-yyyy');
      var todt = this.datePipe.transform(new Date(), 'MM-dd-yyyy');
      this.ExoStarServices.GetRxAuditLogDetails(this.data.drug, todt, fromdt).subscribe(
        results => {
          // this.epcsAuditList=results;
          this.dataSource.data = results;
          if (results.length > 0 && results.length != null) {
            this.totalAuditlogRecords = results.length;
            this.dataSource.sort = this.sort;
          } else {
            this.totalAuditlogRecords = results.length;
          }
          //this.dataSource.data = this.epcsAuditList;

          setTimeout(() => {
            this.dataSource.sort = this.sort;
          })
        }, (err: any) => {
          console.log(err);
        });
    }
  }
  fileName = 'Audit log Report.xlsx';
  ondOownLoadFile(fileFormat: string) {
    const exportData = (this.dataSource.data as any[]).map(element => ({
      'Date and Time': this.datePipe.transform(element.createdOn, 'MM/dd/yyyy, hh:mm:ss a'),
      'Event Created By': element.eventCreatedBy,
      'Provider': element.providerName,
      'Patient': element.patientName,
      'Drug Info': element.drugDescription,
      'Schedule Type': element.scheduleType,
      'Event Type': element.eventType,
      'Event Status': element.eventStatus
    }));

    switch (fileFormat) {
      case 'CSV':
        const options = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          useTextFile: false,
          showTitle: false,
          useBom: true,
          useKeysAsHeaders: true,
          filename: 'Audit log Report',
        };
        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(exportData);
        return false;

      case 'XLS':
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Audit log Report');
        /* save to file */
        XLSX.writeFile(wb, this.fileName);
        return false;

      // case 'PDF':
      //   // let data = document.getElementById('divId');  
      //   // html2canvas(data).then(canvas => {
      //   // const contentDataURL = canvas.toDataURL('image/png')  
      //   // let pdf = new jspdf('l', 'cm', 'a4'); //Generates PDF in landscape mode
      //   // // let pdf = new jspdf('p', 'cm', 'a4'); Generates PDF in portrait mode
      //   // pdf.addImage(contentDataURL, 'PNG', 0, 0, 29.7, 21.0);  
      //   // pdf.save('Filename.pdf'); 
      //   return false;
    }
  }

  onCancel() {
    this.dialogRef.close();
  }

  transform(value: string): string {
    if (value && value != undefined) {
      var datePipe = new DatePipe("en-US");
      value = datePipe.transform(value, 'MM/dd/yyyy');
    }
    return value;
  }


}
export interface DialogData {
  drug: string;
  isRx: boolean;
}
